var _rect, _circle, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 82,
    viewBox: "0 0 50 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 69.2969,
    width: 2,
    height: 12.7042,
    rx: 1,
    fill: "#232323"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20.2812,
    width: 1.81438,
    height: 14.5151,
    rx: 0.907191,
    transform: "rotate(-45 19 20.2812)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2832,
    y: 30.5469,
    width: 1.81438,
    height: 14.5151,
    rx: 0.907191,
    transform: "rotate(-135 20.2832 30.5469)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49.6602,
    width: 2,
    height: 15.0141,
    rx: 1,
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopClosed);
export default __webpack_public_path__ + "static/media/pop_closed.31016244e0a5e1e004730255c0371fe1.svg";
export { ForwardRef as ReactComponent };